import fetchJSON from '@api/api_helper';

export const destroy = (ruleKey) => {
  const url = () => `/api/v4/rules/${ruleKey}`;
  return fetchJSON(url(), {
    method: 'DELETE'
  }).catch(async (response) => { throw (await response.json()); });
};

export const run = (ruleKey) => {
  const url = () => `/api/v4/rules/${ruleKey}/run`;
  return fetchJSON(url(), {
  }).catch(async (response) => { throw (await response.json()); });
};

export const update = ({ ruleKey: rule_key, scope, actionableKeys: actionable_keys }) => {
  const url = () => `/api/v4/rules/${rule_key}`;
  return fetchJSON(url(), {
    method: 'PUT',
    body: {
      data: {
        attributes: {
          scope,
          actionable_keys
        }
      }
    }
  }).catch(async (response) => { throw (await response.json()); });
};
